export default {
  hasTakeAwayMenu: null,
  orders: [],
  preOrders: []
}
